import { createSlice } from '@reduxjs/toolkit';

const overlaySlice = createSlice({
  name: 'overlay',
  initialState: {
    showingSubredditAdder: false,
    showingChannelCreator: false,
    message: null,
    galleryImages: [],
  },
  reducers: {
    setShowingSubredditAdder(state, action) {
      state.showingSubredditAdder = action.payload;
    },
    setShowingChannelCreator(state, action) {
      state.showingChannelCreator = action.payload;
    },
    closeModal(state) {
      state.showingSubredditAdder = false;
      state.showingChannelCreator = false;
    },
    setMessage(state, action) {
      state.message = action.payload;
    },
    setGalleryImages(state, action) {
      state.galleryImages = action.payload;
    },
  },
});

export const {
  closeModal,
  setGalleryImages,
  setMessage,
  setShowingChannelCreator,
  setShowingSubredditAdder,
} = overlaySlice.actions;

export const selectOverlay = state => state.overlay;

export default overlaySlice.reducer;
